import { appState } from '../app.state';
import type { CommandName } from '../commands/command-name.enum';

/**
 * Checks if the current user has a specific privilege synchronously.
 *
 * Reads appState.privileges directly (synchronous operation) instead of
 * calling the async AuthorizationService.canExecute() method.
 *
 * An empty privileges array means "admin" (all privileges granted) per
 * AuthorizationService.hasPrivilege() logic.
 *
 * @param commandName - The command name to check (e.g., CommandName.CREATE_ISSUE).
 * @returns true if the user has the privilege, false otherwise.
 */
export function hasPrivilege(commandName: CommandName): boolean {
    if (appState.privileges.length === 0) {
        return true;
    }
    return appState.privileges.includes(commandName);
}
